<template lang="pug">
  v-dialog(v-model="showing" max-width=600 scrollable)
    template(v-slot:activator="{on}")
      slot(name="activator" :on="on")
        v-btn(icon v-on="on" :color="editable ? 'white': 'primary'" x-small)
          v-icon(size="24" v-if="!editable") mdi-plus
          v-icon(size="16"  v-if="editable") mdi-circle-edit-outline
    template(v-slot:default="courseChoose")
      v-card
        v-card-title
          span
            v-btn(icon color="black" small @click="toggle").mr-2
              v-icon mdi-arrow-left
            span {{ title }} configuration
        crudBody(
          :formErrors="formErrors"
          :item="formData"
          @update:meeting_room="autofillByLocation"
          :cbr_location.sync="formData.cbr_location"
          :name.sync="formData.name"
          :gather_time.sync="formData.gather_time"
          :course_start_time.sync="formData.course_start_time"
          :course_end_time.sync="formData.course_end_time"
          :exam_time.sync="formData.exam_time"
          :transport_type.sync="formData.transport_type"
          :first_day_course_date.sync="formData.first_day_course_date"
          :first_day_course_start_time.sync="formData.first_day_course_start_time"
          :first_day_course_end_time.sync="formData.first_day_course_end_time"
          :is_independent_exam.sync="formData.is_independent_exam"
          :needToReset="showing"
          :editable="editable"
          :locations="locations"
        )
        v-card-actions
          confirmation-dialog(
            v-model="removeModal"
            @okBtnClicked="remove"
            v-if="editable"
            width="420px"
            title='Removing configuration'
            descr='Are you sure you want to remove configuration'
          )
          v-btn(color="error" icon @click="removeModal = true" v-if="editable") 
            v-icon mdi-delete 
          v-spacer
          v-btn(color="error" text @click="toggle") Close
          v-btn(color="success" text @click="submit") Apply
</template>
<script>
import errorsMixin from '@/mixins/errors.mixin'
import FormErrors from "@/util/form-errors"
import { mapGetters, mapActions } from 'vuex'
import { DATETIME, REQUIRED, DATE_INDIAN } from '@/util/validation-rules'
import CMLocationConfigModel from "../../classes/CMLocationConfigModel"
import CMLocationValidator from "../../classes/CMLocationValidator"

export default {
  mixins: [errorsMixin],
  props: {
    ID: Number,
    editable: Boolean,
    item: Object,
  },
  data: () => ({
    formData: new CMLocationConfigModel(),
    showing: false,
    formErrors: new FormErrors(),
    CMLocationValidator: new CMLocationValidator(),
    loading: false,
    removeModal: false
  }),

  computed: {
    ...mapGetters({
      _locations: 'courseLocations/items'
    }),
    locations() {
      if(!this._locations) return []
      return [{
        textToShow: 'No meeting room',
        id: -1,
        address: ''
      }, ...this._locations]
    },
    disabledAction() {
      if(this.disabled) return true
      return false
    },
    title() {
      return this.editable ? 'Edit' : 'Add'
    }
  },

  mounted() {
  },

  inject: ['svc'],

  methods: { 
    ...mapActions({
      getExamLocation: 'crmExamLocation/list',
      getCourseLocation: 'crmCourseCities/list',

      getProductNames: 'crmProductNames/list',
      removeConfiguration: 'locationConfigurations/remove'
    }),
    toggle() {
      this.showing = !this.showing
    },

    Svc() {
      return this.svc()
    },

    submit() {
      this.formErrors.resetFields()
      if(!this.validate(this.formErrors)) {
        this.$notify({text: 'Invalid fields', type: 'error'})
        return
      }
      if(this.editable) this.update()
      else this.send()
    },

    validate(formErrors) {
      let valid = new CMLocationValidator(this.formData, this.formErrors)
      return valid.isValid()
    },

    updateVal(val, field) {
      this.formData[field] = val
    },

    async send(payload) {
      try {
        let res = await this.svc.createCourseConfiguration(this.ID, this.formData)
        this.$notify({text: 'Success', type: 'success'})
        this.toggle()
        this.$emit('create')
      } catch (error) {
        console.log(error)
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.apiAttrs
        });
      }
    },

    async update(payload) {
      try {
        console.log(this.formData)

        let res = await this.svc.updateCourseConfiguration(this.ID, this.item.id, this.formData)
        this.$notify({text: 'Success', type: 'success'})
        this.$emit('update', {
          id: this.item.id, 
          data: res
        })
        this.toggle()
        
      } catch (error) {
        console.log(error)
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.apiAttrs
        });
      }
    },

    reset() {
      this.formData = new CMLocationConfigModel()
      this.formErrors.resetFields()
    },

    editableFormData() {
      this.autofillByLocation(this.item.meeting_room)
      this.formData = {...this.item}
      if(this.editable && this.formData.meeting_room === null) this.formData.meeting_room = -1
    },

    autofillByLocation(locationID) {
      this.formData.meeting_room = locationID
      let data = this.locations.find(location => location.id === locationID)
      console.log(data)
      if((!data)) return
      if(data.id < 0) {
        this.formData.postal_code = ''
        this.formData.route_from = ''
        this.formData.route_link = ''
        this.formData.textToShow = null
        this.formData.city = ''
        this.formData.address = ''
        this.formData.id = null
        return
      }
      for(let field in data) {
        this.formData[field] = data[field]
      }
    },

    async remove() {
      try {
        this.loading = true
        this.removeConfiguration({
          courseID: this.ID,
          configurationID: this.item.id
        })
        this.toggle()
      } catch (error) {
        
      }
      finally {
        this.loading = false
      }
    },
  },

  watch: {
    showing(isShowing) {
      if(this.editable) this.editableFormData()
      if(!isShowing) {
        this.reset()
        return
      }
    }
  },

  components: {
    crudBody: ()=> import('./CMLocationCRUDBody.vue'),
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue'),
  }
}
</script>
